import * as angular from 'angular';
import { reloadCurrentRoute } from '../../../../../../src/app/shared/utils/navigate-force-reload';

class PhoneDontAccept {
    [x: string]: any;
 	 static $inject = ['InboundNumbersService','$stateParams','$state','Toast', 'Router'];
    constructor(InboundNumbersService, $stateParams, $state, Toast, Router) {
        this.InboundNumbersService = InboundNumbersService;
        this.$stateParams = $stateParams;
        this.state = $state;
        this.toast = Toast;
        this.router = Router;
    }

    $onInit() {
        this.settings = angular.copy(this.settings);
        this.msisdnId = this.msisdnid;
    }

    save() {
      const updatedSettings = {...this.settings, checked: true};
      this.settings = updatedSettings;
        this.InboundNumbersService.setNumberSettings({id: this.msisdnid}, {dontAcceptCallConfiguration: this.settings}, () => {
            this.hide();
            this.toast.success('CHANGES_SAVED');
            reloadCurrentRoute(this.router);
        });
    }

    onMessageUpdate() {
      this.InboundNumbersService.getNumberSettings({id: this.msisdnid}, (settings) => {
        this.settings.voicemailMessageFile = settings.dontAcceptCallConfiguration.voicemailMessageFile;
        this.settings.promptMessageFile = settings.dontAcceptCallConfiguration.promptMessageFile;
      });
    }
}

export default {
    controller: PhoneDontAccept,
    template : require('./phone.details.dont-accept.html'),
    bindings: {
        hide: '&',
        settings: '<',
        msisdnid: '<'
    }
};
